import React, { useEffect } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "./BarChart.css";
const RidesIQBarChart  = ({ ridesiqFleetCount })  => {
  const categories = []
  const series = []
  ridesiqFleetCount.map((val) => {
    categories.push(val['label'])
    series.push(val['value'])
  })
  const options = {
    chart: {
      type: "column",
    },
    rangeSelector: {
      selected: 2,
    },
    title: {
      text: "RidesIQ Fleet Info",
      align: "left",
    },
    xAxis: {
      categories: categories,
      crosshair: true,
      accessibility: {
        description: "Category",
      },
    },

    yAxis: {
      min: 1,
      title: {
        text: "Count",
      },
    },

    // tooltip: {
    //   pointFormat:
    //     "<b>{point.category}</b><br>"
    //     // "<b> {point.y}</b><br>",
    // },
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        minPointLength: 3,
      },
    },
    series: [
      {
        name: "Category",
        data: series,
      },
    ],
  };
  return <HighchartsReact highcharts={Highcharts} options={options} />;
};
export default RidesIQBarChart ;